import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "sonner";

import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";

if (
  import.meta.env.ENVIRONMENT === "staging" ||
  import.meta.env.ENVIRONMENT === "production"
) {
  Sentry.init({
    environment: import.meta.env.ENVIRONMENT,
    dsn: "https://2938882c8394d2f91c6f646175525e99@o4508684364611584.ingest.us.sentry.io/4508695493148672",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/notakitchensink\.com/,
      /^https:\/\/app\.quantizr\.com/,
    ],
    // Session Replay (disabled for now)
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });
}

const postHogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY ?? "");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={postHogOptions}
    >
      <Toaster position="top-right" richColors />
      <App />
    </PostHogProvider>
    <ToastContainer />
  </React.StrictMode>
);
